// Progressive enhancement: without this module, every section remains visible.
const motion = matchMedia('(prefers-reduced-motion: reduce)');
const pending = new Set();
const seen = new WeakSet();
const reveal = (element) => {
  element.removeAttribute('data-cdaily-reveal');
  pending.delete(element);
  observer?.unobserve(element);
};
const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  for (const entry of entries) if (entry.isIntersecting) reveal(entry.target);
}, { threshold: 0.05 }) : null;

function initialize(root) {
  if (!observer || motion.matches) return;
  const belowFold = [];
  for (const section of root.querySelectorAll('.cdaily-home:not(.cdaily-home--hero)')) {
    if (seen.has(section)) continue;
    seen.add(section);
    // Never hide content already in view or being edited.
    if (window.Shopify?.designMode || section.getBoundingClientRect().top < innerHeight) continue;
    belowFold.push(section);
  }
  for (const section of belowFold) {
    section.setAttribute('data-cdaily-reveal', 'pending');
    pending.add(section);
    observer.observe(section);
  }
}

initialize(document);
document.addEventListener('shopify:section:load', (event) => initialize(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  for (const section of pending) if (event.target.contains(section)) reveal(section);
});
motion.addEventListener('change', () => {
  if (motion.matches) for (const section of pending) reveal(section);
});
